<script setup lang="ts">
import { ref, watch } from "vue";
import Modal from "./Modal.vue";
import Button from "./Button.vue";
import type { Note } from "../api/types";
import { t } from "../i18n";
import { mediaLabel } from "../api/mappers";
import { timeLabel } from "../api/mappers";
const props = defineProps<{ open: boolean; notes: Note[]; busy?: boolean }>();
const emit = defineEmits<{ close: []; confirm: [body: string] }>();
const body = ref("");
watch(
  () => props.open,
  (v) => {
    if (v) body.value = "";
  },
);
</script>
<template>
  <Modal :open="open" :title="t('note.title')" @close="emit('close')">
    <div class="modal-form">
      <div v-if="notes.length" class="notes-list">
        <div v-for="n in notes" :key="n.id" class="note-item">
          <strong v-if="n.mentioned?.length" class="note-forwarded-to">{{
            t("notes.forwarded_to", {
              names: n.mentioned.map((x) => x.name).join(", "),
            })
          }}</strong>
          {{ n.body }}
          <blockquote
            v-for="f in n.forwarded ?? []"
            :key="f.messageId"
            class="note-quote"
          >
            {{ f.text || f.name || mediaLabel(f.type) }}
          </blockquote>
          <small>{{ n.member_name }} · {{ timeLabel(n.created_at) }}</small>
        </div>
      </div>
      <textarea
        v-model="body"
        rows="3"
        :placeholder="t('note.placeholder')"
        maxlength="4000"
      />
    </div>
    <template #footer>
      <Button variant="secondary" @click="emit('close')">{{
        t("common.cancel")
      }}</Button>
      <Button
        :loading="busy"
        :disabled="!body.trim()"
        @click="emit('confirm', body.trim())"
        >{{ t("note.save") }}</Button
      >
    </template>
  </Modal>
</template>
